<template>
  <div class="flex items-start profile-role-hld">
    <div
      class="profile-image-circle"
      style="height: 50px; width: 50px; margin-right: 10px; margin-top: 5px"
    >
      <img
        height="36px"
        width="36px"
        v-if="
          params.MappedLocations &&
          params.locationList &&
          getImage(params.MappedLocations[0], params.locationList)
        "
        :src="getImage(params.MappedLocations[0], params.locationList)"
      />
      <!-- <span v-else>{{ getInitials(getName(params.MappedLocations[0], params.locationList)) }}</span> -->
      <img
        v-else-if="params.MappedLocations && params.MappedLocations.length > 0"
        height="36px"
        width="36px"
        src="../../../assets/images/checkin-images/location-default.svg"
      />
      <!-- <div
        v-else
        style="height:36px;width:36px;"
      ></div> -->
      <!-- <span v-else>{{ getInitials(getName(params.MappedLocations[0], params.locationList)) }}</span> -->
    </div>
    <div class="location-hld">
      <div
        v-if="
          params.MappedLocations &&
          params.locationList &&
          getName(params.MappedLocations[0], params.locationList)
        "
        style="line-height: 48px"
        class="location-name-hld"
      >
        {{ getName(params.MappedLocations[0], params.locationList) }}
        <!-- <span v-if="params.MappedLocations.length > 1">
          {{ " +" + (params.MappedLocations.length - 1) }}
        </span> -->
        <vx-tooltip
          v-if="getNames(params.MappedLocations, params.locationList)"
          :text="getNames(params.MappedLocations, params.locationList)"
          position="top"
        >
          <span v-if="params.MappedLocations.length > 1">
            {{ " +" + (params.MappedLocations.length - 1) }}
          </span>
        </vx-tooltip>
      </div>
      <div v-else class="location-name-hld" style="line-height: 48px">
        Not Mapped
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererRole",
  methods: {
    getInitials: function (str) {
      var result = "";
      if (str) {
        str = str.trim();
        if (str) {
          var matches = str.match(/\b(\w)/g);
          if (matches) {
            result = matches.join("");
            if (result.length > 2) {
              result = result.substring(0, 2);
            }
          } else {
            result = str.substring(0, 2);
          }
        }
      }
      return result.toUpperCase();
    },
    getName(id, locationList) {
      var result = "Not Mapped";
      for (let i = 0; i < locationList.length; i++) {
        if (locationList[i].LocationId == id) {
          result = locationList[i].Name;
          break;
        }
      }
      return result;
    },
    getNames(mappedLocations, locationList) {
      var result = "";
      for (let i = 0; i < locationList.length; i++) {
        if (mappedLocations.includes(locationList[i].LocationId)) {
          result += locationList[i].Name + ", ";
        }
      }
      if (result.length > 0) {
        result = result.substring(0, result.length - 2);
      }
      //alert(result)
      return result;
    },
    getImage(id, locationList) {
      var result = "";
      for (let i = 0; i < locationList.length; i++) {
        if (locationList[i].LocationId == id) {
          result = locationList[i].ImageUrl;
          break;
        }
      }
      return result;
    },
  },
  computed: {},
};
</script>
<style scoped>
.profile-image-circle img,
.profile-image-circle span {
  line-height: 36px;
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
  display: inline-block;
  height: 36px;
  width: 36px;
  /* border: 1px solid #000; */
  border-radius: 50%;
  background: #dbdbdb;
}
.location-name-hld .con-vs-tooltip {
  display: inline-block !important;
}
.location-name-hld .info-option-wrapper {
  display: inline-block !important;
}
</style>